import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';

const getFileName = (contentDisposition) =>
  contentDisposition?.match(/filename="?([^"]+)"?/)?.[1] ||
  'suivi-retours-tournee.xlsx';

/**
 * Export Excel des envois de la liste, avec les filtres courants (dates, état, recherche).
 */
export default function useExportTourLogs() {
  const [isLoading, setIsLoading] = useState(false);

  const exportTourLogs = async ({ query, state, start_date, end_date }) => {
    try {
      setIsLoading(true);
      const params = Object.fromEntries(
        Object.entries({ query, state, start_date, end_date }).filter(
          ([, value]) => value
        )
      );
      const response = await fleetApi.get(
        buildUrlWithParams('/tours/tours-logs/export', params),
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = getFileName(response.headers['content-disposition']);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      const total = Number(response.headers['x-export-total']);
      const exported = Number(response.headers['x-export-count']);
      if (total > exported) {
        toast.info(
          `Export limité aux ${exported.toLocaleString('fr-FR')} envois les plus récents sur ${total.toLocaleString('fr-FR')} : affinez les dates pour tout exporter.`
        );
      } else {
        toast.success(
          `${exported.toLocaleString('fr-FR')} envoi${exported > 1 ? 's' : ''} exporté${exported > 1 ? 's' : ''}.`
        );
      }
    } catch (error) {
      toast.error('L’export a échoué. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, exportTourLogs };
}
